var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-warpper',{attrs:{"title":"联系我们","en":"CONTACT Us"}},[_c('div',{staticClass:"contactUs"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.pageData.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }